import BaseState from "Engine/base/states/BaseState";
import GlobalDispatcher from "Engine/events/GlobalDispatcher";
import EntryPoint from "Engine/EntryPoint";

export default class RequestRollingState extends BaseState {
    constructor(stateData) {
        super(stateData);
    }

    addListeners() {
        super.addListeners();
        GlobalDispatcher.add('model:getServerData', this.onGetServerData, this);
    }

    onGetServerData(data) {
        if(data.params === 'spin') {
            this.complete();
        }
    }

    start() {
        super.start();
        GlobalDispatcher.dispatch('rollingState:start');
    }
}